import { render } from "./BlockTransaction.vue?vue&type=template&id=6765415e"
import script from "./BlockTransaction.vue?vue&type=script&lang=js"
export * from "./BlockTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__